import { render } from "./media_modal.vue?vue&type=template&id=a080a8e6"
import script from "./media_modal.js?vue&type=script&lang=js"
export * from "./media_modal.js?vue&type=script&lang=js"

import "./media_modal.vue?vue&type=style&index=0&id=a080a8e6&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__